/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetCart200ResponseInner
 */
export interface GetCart200ResponseInner {
    /**
     * 
     * @type {string}
     * @memberof GetCart200ResponseInner
     */
    internalCode: string;
    /**
     * 
     * @type {number}
     * @memberof GetCart200ResponseInner
     */
    quantity: number;
}

/**
 * Check if a given object implements the GetCart200ResponseInner interface.
 */
export function instanceOfGetCart200ResponseInner(value: object): value is GetCart200ResponseInner {
    if (!('internalCode' in value) || value['internalCode'] === undefined) return false;
    if (!('quantity' in value) || value['quantity'] === undefined) return false;
    return true;
}

export function GetCart200ResponseInnerFromJSON(json: any): GetCart200ResponseInner {
    return GetCart200ResponseInnerFromJSONTyped(json, false);
}

export function GetCart200ResponseInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCart200ResponseInner {
    if (json == null) {
        return json;
    }
    return {
        
        'internalCode': json['internalCode'],
        'quantity': json['quantity'],
    };
}

export function GetCart200ResponseInnerToJSON(json: any): GetCart200ResponseInner {
    return GetCart200ResponseInnerToJSONTyped(json, false);
}

export function GetCart200ResponseInnerToJSONTyped(value?: GetCart200ResponseInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'internalCode': value['internalCode'],
        'quantity': value['quantity'],
    };
}

